'use client';

import { Button } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import { getCommunityTranslationKey } from '@utils/businessUtils/getCommunityTranslationKey';
import type { ClosedCommunity } from '@utils/businessUtils/types';

type BrowseAssortmentButtonProps = {
  closedCommunityData?: ClosedCommunity | null;
  landingPageUrl?: string | null;
};

export const BrowseAssortmentButton = ({
  closedCommunityData,
  landingPageUrl
}: BrowseAssortmentButtonProps) => {
  const { t } = useTranslation('webshop.business.communities');

  const communityTypeLabel = t(getCommunityTranslationKey(closedCommunityData?.type));

  const handleClick = () => {
    window.location.href = landingPageUrl || '/';
  };

  return (
    <Button variant='primary' onClick={handleClick} fullWidth>
      {t('browseYourAssortment', { communityType: communityTypeLabel })}
    </Button>
  );
};
